<template>
  <button
    class="flex items-center justify-center inline-block w-10 h-10 p-3 bg-white rounded-full  text-brand-500"
  >
    <i class="block -ml-1 fal fa-chevron-left"></i>
  </button>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>
